import { TPAComponentProps } from '../../types';
import { ErrorMessageWrapperProps } from '../internal/ErrorMessageWrapper';

export interface RatingsInputProps extends TPAComponentProps {
  /**
   * Callback when star is selected
   */
  onSelect?(value: number): void;
  /**
   * Value of the input.
   */
  value?: number;
  /**
   * Label for input.
   */
  label?: string;
  /**
   * Size of the input.
   */
  size?: RatingsInputSize;
  /**
   * Defines label and reaction label placements..
   */
  labelLayout?: RatingsInputLayout;
  /**
   *  Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   */
  getReactionLabel?(value: number): string;
  /**
   * Disables the input.
   */
  disabled?: boolean;
  /**
   * Error to be shown.
   */
  errorMessage?: string;
  /** Appearance of error message. TextOnly | BackgroundAndBorder */
  errorAppearance?: ErrorMessageWrapperProps['errorAppearance'];
  /**
   *  Shows or hides reaction label when getReactionLabel is passed. Defaults to true.
   */
  showReactionLabel?: boolean;
}

export type RatingsInputSize = 'small' | 'large';

export type RatingsInputLayout = 'labelTop' | 'labelAside';

export interface RatingsInputHandle {
  focus(options?: FocusOptions): void;
  blur(): void;
}
